import React, { useState } from 'react';
import { DashboardLayout } from './components/DashboardLayout';
import { ParticipantManagementView, LiquidityMonitoringView, SettlementConfigView, FeeManagementView, TransactionInvestigationView, SystemRepositoriesView, TechnicalConstraintsView, AliasManagementView } from './components/views';
export function App() {
  const [activeModule, setActiveModule] = useState('constraints'); // Default to Constraints to show the work
  const renderContent = () => {
    switch (activeModule) {
      case 'participants':
        return <ParticipantManagementView data-id="element-0" />;
      case 'aliases':
        return <AliasManagementView data-id="element-1" />;
      case 'liquidity':
        return <LiquidityMonitoringView data-id="element-2" />;
      case 'settlement':
        return <SettlementConfigView data-id="element-3" />;
      case 'fees':
        return <FeeManagementView data-id="element-4" />;
      case 'investigations':
        return <TransactionInvestigationView data-id="element-5" />;
      case 'repositories':
        return <SystemRepositoriesView data-id="element-6" />;
      case 'constraints':
        return <TechnicalConstraintsView data-id="element-7" />;
      default:
        return <TechnicalConstraintsView data-id="element-8" />;
    }
  };
  return <DashboardLayout activeModule={activeModule} onModuleChange={setActiveModule} data-id="element-9">
      {renderContent()}
    </DashboardLayout>;
}